import Big from "big.js";

/*
 * 个税--3种题型申报表报送信息计算hook
 */
export function usePersonTaxSummary(currentAns) {
    const currentQa = inject('provideCurrentQa');
    const allQaList = inject('provideAllQa');

    const resDataList = ref([])
    const All_Answer_TaxCreditPayable = ref('0.00') // 最终的应补/退税额，所有前面的题目+当前题的合计

    onMounted(() => {
        // 比当前题号小的其他的个税题
        const otherPersonTaxQa = allQaList.value.filter(f => f.queType == '5' && f.queNo < currentQa.value.queNo)

        // 所有比当前小题目的用户答案，增加了字段sonQueType，便于分组
        let allUserAnswer = []
        otherPersonTaxQa.forEach(qa => {
            allUserAnswer = allUserAnswer.concat((JSON.parse(qa.solution)?.userAnswer || []).map(m => ({
                ...m,
                sonQueType: qa.sonQueType,
            })))
        })
        allUserAnswer = allUserAnswer.concat(currentAns.map(m => ({
            ...m,
            sonQueType: currentQa.value.sonQueType,
        })))


        // 根据个税类型分组
        const groupData = allUserAnswer.reduce((prev, item) => {
            const find = prev.find(s => s.sonQueType == item.sonQueType)
            if (!find) {
                prev.push({
                    sonQueType: item.sonQueType,
                    itemsOrigin: [item],
                    name: {
                        '51': '正常工资薪金所得',
                        '52': '全年一次性奖金收入',
                        '53': '劳务报酬(一般、法律援助补贴、其他非连续劳务)'
                    }[item.sonQueType],
                })
            } else {
                find.itemsOrigin.push(item)
            }
            return prev
        }, [])


        let t_Answer_TaxCreditPayable = new Big(0)
        groupData.forEach(group => {
            group.person = group.itemsOrigin.length
            let Answer_CurrentIncome = new Big(0) // 累计收入额
            let Answer_ShouldTaxMount = new Big(0) // 应扣缴税款
            let Answer_TheAmountTaxWithheld = new Big(0) // 已扣缴税款
            let Answer_TaxCreditPayable = new Big(0) // 应补（退）税额

            group.itemsOrigin.forEach(singleData => {
                Answer_CurrentIncome = Answer_CurrentIncome.plus(singleData.Answer_CurrentIncome || 0)
                Answer_ShouldTaxMount = Answer_ShouldTaxMount.plus(singleData.Answer_ShouldTaxMount || 0)
                Answer_TheAmountTaxWithheld = Answer_TheAmountTaxWithheld.plus(singleData.Answer_TheAmountTaxWithheld || 0)
                Answer_TaxCreditPayable = Answer_TaxCreditPayable.plus(singleData.Answer_TaxCreditPayable || 0)

                t_Answer_TaxCreditPayable = t_Answer_TaxCreditPayable.plus(singleData.Answer_TaxCreditPayable || 0)
            })
            group.Answer_CurrentIncome = Answer_CurrentIncome.toFixed(2)
            group.Answer_ShouldTaxMount = Answer_ShouldTaxMount.toFixed(2)
            group.Answer_TheAmountTaxWithheld = Answer_TheAmountTaxWithheld.toFixed(2)
            group.Answer_TaxCreditPayable = Answer_TaxCreditPayable.toFixed(2)
        })

        All_Answer_TaxCreditPayable.value = t_Answer_TaxCreditPayable.toFixed(2)
        resDataList.value = groupData
    })

    return {
        resDataList,
        All_Answer_TaxCreditPayable, // 最终的应补/退税额，所有前面的题目+当前题的合计
    }
}

/*
 * 个税，当前题目前面的题目汇总，用于“综合所得申报”根列表页面统计
 */
export function useBeforeTaxSummary() {
    const currentQa = inject('provideCurrentQa');
    const allQaList = inject('provideAllQa');

    const resDataList = ref([])

    onMounted(() => {
        // 比当前题号小的其他的个税题
        const otherPersonTaxQa = allQaList.value.filter(f => f.queType == '5' && f.queNo < currentQa.value.queNo)

        // 所有比当前小题目的用户答案，增加了字段sonQueType，便于分组
        let allUserAnswer = []
        otherPersonTaxQa.forEach(qa => {
            allUserAnswer = allUserAnswer.concat((JSON.parse(qa.solution)?.userAnswer || []).map(m => ({
                ...m,
                sonQueType: qa.sonQueType,
            })))
        })


        // 根据个税类型分组
        const groupData = allUserAnswer.reduce((prev, item) => {
            const find = prev.find(s => s.sonQueType == item.sonQueType)
            if (!find) {
                prev.push({
                    sonQueType: item.sonQueType,
                    itemsOrigin: [item],
                    name: {
                        '51': '正常工资薪金所得',
                        '52': '全年一次性奖金收入',
                        '53': '劳务报酬(一般、法律援助补贴、其他非连续劳务)'
                    }[item.sonQueType],
                })
            } else {
                find.itemsOrigin.push(item)
            }
            return prev
        }, [])


        groupData.forEach(group => {
            group.person = group.itemsOrigin.length
            let Answer_CurrentIncome = new Big(0) // 累计收入额

            group.itemsOrigin.forEach(singleData => {
                Answer_CurrentIncome = Answer_CurrentIncome.plus(singleData.Answer_CurrentIncome || 0)
            })
            group.Answer_CurrentIncome = Answer_CurrentIncome.toFixed(2)
        })
        //console.log('分组后数据', groupData)
        resDataList.value = groupData
    })

    return {
        resDataList,
    }
}
